import { useStateContext } from "./state";
import { Button } from "@/kit/ui/button";
import { FormattedMessage } from "react-intl";
import { FormattedDataSize } from "@/components/FormattedDataSize";
import {
  CircularProgress,
  CircularProgressCircles,
  CircularProgressContent,
  CircularProgressIndicator,
  CircularProgressOutline,
} from "@/kit/ui/circular-progress";

export const UploadContents = () => {
  const { files, cancelUpload, processedBytes } = useStateContext();
  const totalBytes = files.reduce(
    (sum, file) => sum + BigInt(file.size),
    BigInt(0),
  );
  const progress = Number((processedBytes * BigInt(100)) / totalBytes);
  return (
    <div className="flex flex-col space-y-4 py-4 items-center">
      <CircularProgress>
        <CircularProgressCircles>
          <CircularProgressOutline />
          <CircularProgressIndicator progress={progress} />
        </CircularProgressCircles>
        <CircularProgressContent className="text-lg font-semibold">
          {progress}%
        </CircularProgressContent>
      </CircularProgress>
      <div className="text-center">
        <p className="text-sm text-grey-600 font-regular">
          <FormattedMessage defaultMessage="Converting dataset..." />
        </p>
        <p className="text-sm text-grey-700 font-medium">
          <FormattedDataSize bytes={processedBytes} />
          {" / "}
          <FormattedDataSize bytes={totalBytes} />
        </p>
      </div>
      <Button
        variant="secondary"
        className="w-full"
        onClick={() => cancelUpload()}
      >
        <FormattedMessage defaultMessage="Cancel" />
      </Button>
    </div>
  );
};
